/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { inject } from '@angular/core';
import { ZoomExtentsCommand } from './zoom-extents.command';
import { MapService } from '../../services/map.service';
import { MapConfigService } from '../../services/map-config.service';

export function zoomExtentsFactory() {
    const command = new ZoomExtentsCommand();
    command.setDependencies({
        mapService: inject(MapService),
        mapConfig: inject(MapConfigService),
    });
    return command;
}
